import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';


export interface Search {
	eventTitle: string;
	venueName: string;
	from: string;
	to: string;
}

@Component({
	selector: "event-with-venue-search-box",
	templateUrl: "./event-with-venue-search-box.html",
	styles: [require("./event-with-venue-search-box.scss")]
})
export class EventWithVenueSearchBox {

	@Input() set search(search: Search) {
		this._search = search
	}

	@Output() searchChange = new EventEmitter<Search>();
	@Output() resetSearch = new EventEmitter<void>();

	private _search: Search;
	private form: FormGroup;

	constructor(private formBuilder: FormBuilder) {
	}


	ngOnInit() {
		this.form = this.formBuilder.group({
			"eventTitle": "",
			"venueName": "",
			"from": "",
			"to": ""
		})
		this.form.valueChanges.debounceTime(300).subscribe((search) => {
			this.searchChange.emit(search);
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/events-on-sale/event-with-venue-search-box/event-with-venue-search-box.component.ts